import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
  
import { LoginContext } from './App';
import { NavigateSmart } from './Common';


export const TwoFactorRoute = ({setup2faUrl}) => {
    const login = useContext(LoginContext);

    return (
        !login.loggedIn ?
            null
        :
            login.twoFactorAuthEnabled ?
                <Outlet />
            :
                <NavigateSmart to={setup2faUrl} />
    );
};

export default TwoFactorRoute
